import axios from 'axios'
import create from 'zustand'
import { persist } from 'zustand/middleware'
import Cookies from 'js-cookie'

//#region attend store
let store = (set) => ({
  // store attends
  attends: {},
  // store attends basd on student
  attendsBaseOnStudent: {},
  // store attends basd on supervisor
  attendsBaseOnSupervisor: {},
  attendsBaseOnSupervisorAndStudent: {},
  // get All attends
  getAttends: async () => {
    // setting token
    let token = Cookies.get('token')

    // attach token to header
    // sort and order data by which column and how
    const config = {
      headers: {
        Authorization: 'Bearer ' + token,
      },
      params: {
        sortBy: 'attend.id',
        orderBy: 'desc',
      }
    }
    // setting url 
    // main url comes from .env file
    const apiResponse = await axios.get(`${process.env.REACT_APP_API}/attend`, config)
    set(async (state) => {
      // initilize attends state variable to the responsed attends if request succeed
      if (apiResponse?.status == 200 || apiResponse?.status == 201)
        state.attends = apiResponse.data
    })
  },
  getAttendsBaseOnStudent: async (id) => {
    // setting token
    let token = Cookies.get('token')
    if(!id){
      id = Cookies.get('type')?.substring(40)?.split(',')?.[0] ?? -1;
    }
    // attach token to header
    // sort and order data by which column and how
    const config = {
      headers: {
        Authorization: 'Bearer ' + token,
      },
      params: {
        sortBy: 'courseset.rank',
        orderBy: 'asc',
      }
    }
    // setting url 
    // main url comes from .env file
    const apiResponse = await axios.get(`${process.env.REACT_APP_API}/attend/student/${id}`, config)
    set(async (state) => {
      // initilize attends state variable to the responsed attends if request succeed
      if (apiResponse?.status == 200 || apiResponse?.status == 201)
      state.attendsBaseOnStudent = apiResponse.data
  })
  },
  getAttendsBaseOnSupervisor: async () => {
    // setting token
    let token = Cookies.get('token')
    const id = Cookies.get('type')?.substring(40)?.split(',')?.[0] ?? -1;

    // attach token to header
    // sort and order data by which column and how
    const config = {
      headers: {
        Authorization: 'Bearer ' + token,
      },
      params: {
        sortBy: 'attend.id',
        orderBy: 'desc',
      }
    }
    // setting url 
    // main url comes from .env file
    const apiResponse = await axios.get(`${process.env.REACT_APP_API}/attend/supervisor/${id}`, config)
    set(async (state) => {
      // initilize attends state variable to the responsed attends if request succeed
      if (apiResponse?.status == 200 || apiResponse?.status == 201)
        state.attendsBaseOnSupervisor = apiResponse.data
    })
  },
  getAttendsBaseOnSupervisorAndStudent: async (studentId) => {
    // setting token
    let token = Cookies.get('token')
    const id = Cookies.get('type')?.substring(40)?.split(',')?.[0] ?? -1;

    // attach token to header
    // sort and order data by which column and how
    const config = {
      headers: {
        Authorization: 'Bearer ' + token,
      },
      params: {
        sortBy: 'attend.id',
        orderBy: 'desc',
      }
    }
    // setting url 
    // main url comes from .env file
    const apiResponse = await axios.get(`${process.env.REACT_APP_API}/attend/supervisor/${id}/student/${studentId}`, config)
    set(async (state) => {
      // initilize attends state variable to the responsed attends if request succeed
      if (apiResponse?.status == 200 || apiResponse?.status == 201)
        state.attendsBaseOnSupervisorAndStudent = apiResponse.data
    })
  },
  addAttend: async (payload) => {
    // setting token
    let token = Cookies.get('token')

    // attaching token to the header
    const config = {
      headers: {
        Authorization: 'Bearer ' + token,
      },
    }

    // setting url 
    // main url comes from .env file 
    const apiResponse = await axios.post(`${process.env.REACT_APP_API}/attend`, payload, config)
    if (apiResponse?.status === 201) {
      set(async (state) => {
        // initilizing attends state variable to the resoponsed data
        state.attends = {
          data: [apiResponse.data, ...state.attends.data],
          limit: state.attends.limit,
          page: state.attends.page,
          totalCount: state.attends.totalCount + 1,
        }
      })
    }
    return apiResponse
  },
  editAttend: async (payload, attend_ids, coursestatuse_ids) => {
    // setting token
    let token = Cookies.get('token')

    // attaching token to the header
    const config = {
      headers: {
        Authorization: 'Bearer ' + token,
      },
    }

    // setting url 
    // main url comes from .env file 

    // {{url}}/attend/?attend_ids=[7]&coursestatuse_ids=[1]
    // return
    const apiResponse = await axios.patch(`${process.env.REACT_APP_API}/attend?attend_ids=[${attend_ids}]&coursestatuse_ids=[${coursestatuse_ids}]`, payload, config)
    // update attends state variable if update request was succeed
    if (apiResponse?.status === 200) {
      set(async (state) => {
        // const result = state.attends?.data?.find((attend, index) => {

        //   if (attend.id === id) {
        //     state.attends.data[index] = apiResponse?.data
        //   }
        // })

        // state.attends = {
        //   data: [...state.attends.data],
        //   limit: state.attends.limit,
        //   page: state.attends.page,
        //   totalCount: state.attends.totalCount,
        // }
      })
    }
    return apiResponse
  },
  editStandardAttend: async (payload, id) => {
    // setting token
    let token = Cookies.get('token')

    // attaching token to the header
    const config = {
      headers: {
        Authorization: 'Bearer ' + token,
      },
    }

    // setting url 
    // main url comes from .env file 

    const apiResponse = await axios.patch(`${process.env.REACT_APP_API}/attend/edit/${id}`, payload, config)
    // update attends state variable if update request was succeed
    if (apiResponse?.status === 200) {
      set(async (state) => {
        const result = state.attendsBaseOnSupervisor?.data?.find((attend, index) => {

          if (attend.id === id) {
            state.attendsBaseOnSupervisor.data[index] = apiResponse?.data
          }
        })

        // state.attends = {
        //   data: [...state.attendsBaseOnSupervisor.data],
        //   limit: state.attendsBaseOnSupervisor.limit,
        //   page: state.attendsBaseOnSupervisor.page,
        //   totalCount: state.attendsBaseOnSupervisor.totalCount,
        // }
      })
    }
    return apiResponse
  },
  deleteAttend: async (id) => {
    // setting token
    let token = Cookies.get('token')

    // attaching token to the header
    const config = {
      headers: {
        Authorization: 'Bearer ' + token,
      },
    }
    // setting url 
    // main url comes from .env file 
    const apiResponse = await axios.delete(`${process.env.REACT_APP_API}/attend/${id}`, config)
    // delete element in the attends.data array state if the request was succeed
    if (apiResponse?.status === 200) {

      set(async (state) => {
        const arr = state.attends.data.filter(item => item.id !== id)
        state.attends = {
          data: arr,
          limit: state.attends.limit,
          page: state.attends.page,
          totalCount: state.attends.totalCount - 1,
        }
      })

    }

    return apiResponse

  },
})
//#endregion attend store

// store the state in the browser local storage
// store = persist(store, { name: 'attend' })

// getting store data in the browser localstorage
const attend_Store = create(store)

export default attend_Store
